var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4728 0.528769C18.7808 -0.136231 23.5068 0.11677 28.0238 3.40377C31.6788 6.06377 34.1118 10.1238 35.0318 14.4998L35.1688 15.0998C35.9178 18.6988 34.8689 22.5928 33.6029 25.9498L31.6818 29.5828L17.6508 50.1978C11.2868 40.1258 -1.13618 26.1328 0.312818 13.6438C0.490818 12.3278 0.954815 10.9318 1.55382 9.74978C4.00882 4.90978 8.45382 2.09777 13.4728 0.528769Z",
    fill: "url(#paint0_linear_18_863)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.577221 6.05283C1.59022 3.96183 2.60922 2.1278 4.75022 1.0108C7.74322 -0.551196 10.6372 0.289818 13.6682 1.13782C15.4902 3.23882 17.3122 5.55081 16.9922 8.52481C16.7162 11.0908 15.3562 13.3078 13.2782 14.8108C11.5422 16.0658 9.15923 16.4748 7.05723 16.0168C4.69623 15.5028 2.29921 12.9848 1.36521 10.8548C0.686215 9.30683 0.522221 7.73183 0.577221 6.05283Z",
    fill: "#FCFCFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_863",
    x1: 25.3312,
    y1: 47.5221,
    x2: 13.4295,
    y2: 0.391276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C53EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C53EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.1b43acd4c533957e76753e8e04ae09f2.svg";
export { ForwardRef as ReactComponent };